var _a, _b, _c;
import IntegrationProviderContainer from 'components/Integrations/Shared/IntegrationProviderContainer';
import ProductSliderIntegration from 'components/Integrations/productSlider/ProductSliderIntegration';
import lazysizes from 'lazysizes';
import { createRoot } from 'react-dom/client';
import React from 'react';
import { ModalProvider } from 'styled-react-modal';
import { styled } from 'styled-components';
lazysizes.init();
const SpecialModalBackground = styled.div `
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  align-items: center;
  justify-content: center;
  z-index: 9999999;
`;
const container = document.getElementById('st-product-overview-slider');
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container);
root.render(React.createElement(IntegrationProviderContainer, { designSettings: window.__ST_SLIDER_DATA.company.design, locale: window.__ST_SLIDER_DATA.locale },
    React.createElement(ModalProvider, { backgroundComponent: SpecialModalBackground },
        React.createElement(ProductSliderIntegration, { locale: window.__ST_SLIDER_DATA.locale, products: ((_c = (_b = (_a = window.__ST_SLIDER_DATA) === null || _a === void 0 ? void 0 : _a.companyProducts) === null || _b === void 0 ? void 0 : _b.edges) === null || _c === void 0 ? void 0 : _c.map(({ node }) => node)) || [] }))));
